/**
 * Thin axios wrappers around the model integrations (BYO-LLM keys) and the
 * model catalog on /api/evals. The legacy evaluator endpoints were removed.
 */
import axiosInstance from 'shared/services/api/axiosInstance';

const tparams = (teamId, extra = {}) => ({ params: { team_id: teamId, ...extra } });

// -- Integrations (BYO-LLM keys) --------------------------------------------
// `kind`: 'chat' (server default), 'decision' or 'all'. Only Settings → Models
// asks for 'all'; every chat picker keeps the default.
export async function listIntegrations(teamId, { kind } = {}) {
  const { data } = await axiosInstance.get('/evals/integrations', tparams(teamId, kind ? { kind } : {}));
  return data?.integrations || [];
}

export async function createIntegration(teamId, body) {
  const { data } = await axiosInstance.post('/evals/integrations', body, tparams(teamId));
  return data?.integration;
}

// Synced model catalog for a provider — the source of truth for the model
// pickers. Returns { provider, manual, models:[{id,label,family,reasoning,...}],
// profile } where `models` is per-model data from the weekly models.dev sync
// (warn-worthy) and `profile` is the provider's own schema (authoritative).
export async function listModelCatalog(teamId, provider) {
  // team_id is optional — omit when null so the axios x-team-id header resolves
  // the team (the pattern playground uses with no teamId in hand).
  const params = teamId != null ? { team_id: teamId, provider } : { provider };
  const { data } = await axiosInstance.get('/evals/model-catalog', { params });
  return data || { provider, manual: false, models: [], profile: null };
}

export async function deleteIntegration(teamId, id) {
  const { data } = await axiosInstance.delete(`/evals/integrations/${id}`, tparams(teamId));
  return data;
}

export async function updateIntegration(teamId, id, body) {
  const { data } = await axiosInstance.patch(`/evals/integrations/${id}`, body, tparams(teamId));
  return data?.integration;
}
